var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 512,
    viewBox: "0 0 448 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.6 278.6C451.1 266.1 451.1 245.8 438.6 233.3L278.6 73.2998C266.1 60.7998 245.8 60.7998 233.3 73.2998C220.8 85.7998 220.8 106.1 233.3 118.6L338.8 224H32C14.3 224 0 238.3 0 256C0 273.7 14.3 288 32 288H338.7L233.4 393.4C220.9 405.9 220.9 426.2 233.4 438.7C245.9 451.2 266.2 451.2 278.7 438.7L438.7 278.7L438.6 278.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSolid);
export default __webpack_public_path__ + "static/media/arrow-right-solid.7d386bc811588d74b4ea3c31e8eac54a.svg";
export { ForwardRef as ReactComponent };